import i18n from 'i18next'
import { z } from 'zod'

import { availabilityFormSchema } from '@/constants/availability-form'
import type { TimetableSettings } from '@/modules/timetable'
import { labelAndValue, requiredStringWithLabel } from '@/utils/zod'

import { ROOM_TYPES } from '../constants/room-types'

export const roomFormPayload = (workingHours: TimetableSettings) =>
  z.object({
    name: requiredStringWithLabel(i18n.t('label.name', { ns: 'rooms' })).max(
      80,
      i18n.t('error.max-length', { ns: 'common', NUMBER: 80 })
    ),
    capacity: z
      .number({
        required_error: i18n.t('error.required-field-with-label', {
          ns: 'common',
          LABEL: i18n.t('label.capacity', { ns: 'rooms' })
        })
      })
      .min(1, i18n.t('error.min-number', { ns: 'common', NUMBER: 1 }))
      .nullable(),
    type: z.enum(ROOM_TYPES, {
      required_error: i18n.t('error.required-field-with-label', {
        ns: 'common',
        LABEL: i18n.t('label.type', { ns: 'rooms' })
      })
    }),
    specialEquipment: z.string().optional(),
    preferredCourses: z.array(labelAndValue()).optional(),
    preferredUsers: z.array(labelAndValue()).optional(),
    preferredClasses: z.array(labelAndValue()).optional(),
    availability: availabilityFormSchema(workingHours).optional()
  })

export type RoomFormPayload = z.infer<ReturnType<typeof roomFormPayload>>
